import axios from "axios";
import authHeader from '../../../authheader'

const EIRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualEiRenewal";

const getContactInformation = (renewalId) => {
    return axios.get(`${EIRENEWALURL}/contactinformation`, { headers: authHeader(), params: { renewalId } });
}
export default {
    getContactInformation
}